"use strict";

define('components/table',['components/ajax', 'components/dom_setup', 'components/form', 'components/strings', 'select2', 'history', 'components/email_batch_delay_send'], function(ajax, domSetup, formComponent, stringsComponent) {


    var SCROLLBAR_HEIGHT = 9;
    var FIXED_HEADER_ZINDEX = 1027;
    var SELECT2_ZINDEX = 1029;
    var SELECT2_MASK_ZINDEX = 1028;
    var HEADER_DEFAULT_ZINDEX = 2;
    var SIDEBAR_DEFAULT_ZINDEX = 9;
    var tableOverlay = null;

    function getWindowScrollY() {
        if (typeof(window.pageYOffset) == 'number') return window.pageYOffset;
        return window.scrollY;
    }

    function getWindowScrollX() {
        if (typeof(window.pageXOffset) == 'number') return window.pageXOffset;
        return window.scrollX;
    }

    var table = function()  {
        this._tableContainer = null;

        this.setButtonBarVisibility = function(numSelected) {
            if (numSelected > 0) {
                if (!$('#primary-filters > a').hasClass('overlay-close')) {
                    $('#primary-filters').addClass('hidden');
                }
                $('#alpha-filters').addClass('hidden');
                $('#ext-filters').addClass('hidden');
                $('#location-filters').addClass('hidden');
                $('#selection-actions').removeClass('hidden');
                $('#selection-empty-message').addClass('hidden');
            } else {
                $('#selection-empty-message').removeClass('hidden');
                $('#primary-filters').removeClass('hidden');
                if ($('#show-location-filters').hasClass('selected')) {
                    $('#location-filters').removeClass('hidden');
                }
                if($('#show-alpha-filters').hasClass('selected')) {
                    $('#alpha-filters').removeClass('hidden');
                } else {
                    $('#alpha-filters').addClass('hidden');
                }
                if($('#show-ext-filters').hasClass('selected')) {
                    $('#ext-filters').removeClass('hidden');
                } else {
                    $('#ext-filters').addClass('hidden');
                }
                $('#selection-actions').addClass('hidden');
            }

            $('#selection-count-number').html(numSelected);

            if(numSelected == 1) {
                $('#selection-count-singular').removeClass('hidden');
                $('#selection-count-plural').addClass('hidden');
                $('#selection-count-delete-singular').removeClass('hidden');
                $('#selection-count-delete-plural').addClass('hidden');
            } else {
                $('#selection-count-singular').addClass('hidden');
                $('#selection-count-plural').removeClass('hidden');
                $('#selection-count-delete-singular').addClass('hidden');
                $('#selection-count-delete-plural').removeClass('hidden');
            }
        }

        this.updateButtonBar = function() {
            var self = this;

            this.setButtonBarVisibility($('tr > td.cell-checkbox > input').filter(':checkbox').filter(':checked').length);
            if ($('.selection-lead-action').length) {
                var activeCount = 0, disqualifiedCount = 0;
                $('tr > td.cell-checkbox > input').filter(':checkbox').filter(':checked').each(function () {
                    if ($(this).parents('.active-row').hasClass('disabled')) {
                        disqualifiedCount++;
                    } else {
                        activeCount++;
                    }
                });
                if (disqualifiedCount) {
                    $('.selection-lead-reactivate').removeClass('hidden');
                } else {
                    $('.selection-lead-reactivate').addClass('hidden');
                }
                if (activeCount) {
                    $('.selection-lead-disqualify').removeClass('hidden');
                } else {
                    $('.selection-lead-disqualify').addClass('hidden');
                }
            }
            var remove_tag_menu = $('#selection-remove-tag-menu');

            if(remove_tag_menu.length) {
                var tag_id_to_count = {};
                var tag_id_to_name = {};

                $('tr > td.cell-checkbox > input').filter(':checkbox').filter(':checked').each(function() {
                    $(this).parent().parent().find('td.cell-tags button').each(function() {
                        var id = $(this).data('id');
                        if(!(id in tag_id_to_name)) {
                            tag_id_to_name[id] = $(this).text();
                            tag_id_to_count[id] = 1;
                        } else {
                            tag_id_to_count[id]++;
                        }
                    });
                });

                var tag_ids = Object.keys(tag_id_to_name);
                // Show remove tag button only if there tags in the dropdown
                if (tag_ids.length > 0) {
                    $('#selection-remove-tag').show();
                } else {
                    $('#selection-remove-tag').hide();
                }

                tag_ids.sort(function(a, b) {
                    if(tag_id_to_count[b] - tag_id_to_count[a] != 0) {
                        return tag_id_to_count[b] - tag_id_to_count[a];
                    } else {
                        return a.localeCompare(b);
                    }
                });

                remove_tag_menu.empty();

                for(var i = 0; i < tag_ids.length; i++) {
                    var tag_id = tag_ids[i];

                    var menu_item = $('<a data-id="' + tag_id + '"href="#"></a>').text(tag_id_to_name[tag_id]).
                        append(' <span class="text-muted">(' + tag_id_to_count[tag_id] + ')</span>').
                        click(function(e) {
                            e.preventDefault();
                            var this_tag_id = $(this).data('id');

                            var object_type = remove_tag_menu.data('object-type');
                            var url = remove_tag_menu.data('delete-url');

                            var selected_object_ids = self.getSelectedObjectIds();

                            // The csrf_token will be added in the ajax call below.
                            var content = new FormData();
                            content.append("object_type", object_type);
                            content.append("tag_id", this_tag_id);
                            content.append("object_ids", selected_object_ids);      // comma-separated IDs.

                            ajax(url, {
                                formData: content,
                                onSuccess: function() {
                                    for(var j = 0; j < selected_object_ids.length; j++) {
                                        var tag_to_remove = self.findInCell(selected_object_ids[j], 'cell-tags', 'button[data-id="' + this_tag_id + '"]');
                                        tag_to_remove.fadeOut();
                                        tag_to_remove.remove();
                                    }
                                    self.updateButtonBar();
                                }
                            });

                        });
                    remove_tag_menu.append(menu_item);
                    menu_item.wrap('<li></li>');
                }
            }
        }

        this.getSelectedObjectIds = function() {
            var selected_object_ids = new Array();
            $('tr > td.cell-checkbox > input').filter(':checkbox').filter(':checked').each(function() {
                selected_object_ids.push($(this).parent().parent().data('id'));
            });

            return selected_object_ids;
        }

        this.appendToCell = function(object_id, td_class, new_element) {
            $('tr[data-id="' + object_id + '"] > td.' + td_class).append(new_element);
        }

        this.removeFromCell = function(object_id, td_class, selector) {
            $('tr[data-id="' + object_id + '"] > td.' + td_class).remove(selector);
        }

        this.findInCell = function(object_id, td_class, selector) {
            return $('tr[data-id="' + object_id + '"] > td.' + td_class).find(selector);
        }

        this.init = function(tableContainer) {
            var tableEl = tableContainer.find('table');
            if (tableEl.data('tableComponentInitialized')) {
                this._tableContainer = tableContainer;
                return;
            }
            tableEl.data('tableComponentInitialized', true);

            var self = this;

            this._tableContainer = tableContainer;

            // Prevent multiple event registrations
            this._tableContainer.off('.jsqTableContainerEvents');

            this.initFixedHeader();
            this.initTableScroller();
            this.updateButtonBar();

            // Popover for overflowing subject cell in table
            this._tableContainer
                .find('td.cell-subject')
                .each(function() {
                    if (this.scrollWidth > this.clientWidth) {
                        $(this).popover({
                            trigger: 'hover',
                            content: $(this).text().trim(),
                            container: 'body',
                            placement: 'right'
                        });
                    }
                });

            // Auto-expand any expando rows marked for auto-expansion on page load
            this._tableContainer.find('tr.expando.expando-expanded:not(.subheading)').each(function() {
                self.expandRow($(this));
            });

            // Overlays are managed via browser state on the data container
            if (!tableOverlay || tableOverlay.length == 0) {
                tableOverlay = this._tableContainer.closest('.table-overlay');
                if (tableOverlay.length > 0) {
                    // Delegate overlay-close click handling to the table.
                    var dataContainer = tableOverlay.find('.data-container');
                    var overlayContainer = dataContainer.siblings('.overlay-container');
                    overlayContainer.click(function(e) {
                        if ($(e.target).hasClass('overlay-close')) {
                            // remove any filter created in overlay
                            overlayContainer.find('#primary-filters').remove();
                            e.preventDefault();
                            e.stopPropagation();
                            var stateData = {
                                'component': 'table',
                                'tableId': dataContainer.children('.table').attr('id'),
                                'closeOverlay': true
                            };
                            History.pushState(stateData, document.title, dataContainer.data('url'));
                        }
                    });
                    History.Adapter.bind(window,'statechange', $.proxy(this.overlayStateChangeHandler, this));
                }
            }


            // Handle checkbox change events at the container level, in case of dynamic content
            this._tableContainer.on('change.jsqTableContainerEvents', function(event) {
                var target = $(event.target);

                if (target.is('input:checkbox[id^="checkbox_"]')) {
                    self.handleCheckboxToggle(target);
                    self.updateButtonBar();
                }
            });

            function onClickCheckboxCell(cell, event) {
                var checkbox = cell.find('input:checkbox:not(:disabled)');
                if (!checkbox[0]) return;

                checkbox.prop('checked', !checkbox.prop('checked'));
                self.handleCheckboxToggle(checkbox);
                self.updateButtonBar();
                event.stopPropagation();
            }

            // Delegate active-row click handling to the container to handle dynamic table content.
            this._tableContainer.on('click.jsqTableContainerEvents', '.cell-checkbox', function(e) {
                if ($(e.target).is('input:checkbox')) return;
                onClickCheckboxCell($(this), e);
            });

            // Adjusted version of github: /main/commit/9131f82f385039b009765156b2b0f0699f94e126
            // ... #diff-0e1868a49acf5dec6506b1c15858a2afR668
            this._tableContainer.on('click.jsqTableContainerEvents', 'tr.batch-select td:not(.cell-checkbox)', function(e) {
                var checkboxCell = $(this).siblings('td.cell-checkbox');
                onClickCheckboxCell(checkboxCell, e);
            });

            this._tableContainer.find('table').click(function(e) {
                var target = $(e.target);

                // Clicking on an anchor in a table should prevent all other table click handling.
                if (target.is('a')) {
                    return true;
                }

                // The change listener will handle this instead.
                if (target.is('input:checkbox[id^="checkbox_"]')) {
                    e.stopPropagation();
                    return;
                }

                // Handled by a different listener.
                if (target.is('.cell-checkbox')) {
                    return;
                }

                var row = target.closest('tr[data-id], tr[data-href], tr.expando.subheading');
                if (row.length == 0) {
                    row = target.closest('tbody[data-id], tbody[data-href]');
                    if (row.length == 0) {
                        return;
                    }
                }

                if (row.hasClass('expando')) {
                    if (row.hasClass('subheading')) {
                        self.expandSubheading(row);
                    } else {
                        self.expandRow(row);
                    }
                    return;
                }

                if (row.hasClass('overlay')) {
                    self.showOverlay(row);
                    return;
                }

                var cell = target.closest('td');
                if (target.closest('div.table').prop('id') === 'prospect_list'
                    && cell.attr('data-field-name') === "status_id"){
                    var firstDiv = target.closest('div.editable');
                    firstDiv.trigger('jsq:tableCellEdit', [row.data('id'), row.data('href')]);
                    return;
                }

                if (cell.hasClass('editable') && !cell.hasClass('cell-rowspan')) {
                    // Ignore click inside the popover
                    if (target.closest('.popover-content').length > 0) {
                        return;
                    }
                    cell.trigger('jsq:tableCellEdit', [row.data('id'), row.data('href')]);
                    return;
                }

                if (row.data('action') == 'link') {
                    if (e.shiftKey || e.ctrlKey || e.metaKey) {
                        window.open(row.data("href"), '_blank');
                    } else {
                        window.document.location = row.data("href");
                    }
                } else if (row.data('action') == 'poll') {
                    self.pollRows(false/*retry*/);
                    //no-op
                } else if (row.closest('table[data-modal-target]').length != 0 && row.data("href")) {
                    var modalTarget = row.closest('table[data-modal-target]').data('modal-target')
                    //$(modalTarget).modal({remote: row.data("href")});
                    $(modalTarget).find('.modal-content').load(row.data("href"), function (response, status, xhr) {
                        if (status == 'success') {
                            $(modalTarget).trigger('loaded.bs.modal');  // Fired when loaded via the 'remote' option
                            $(modalTarget).modal('show');
                        }
                    });
                } else if (row.closest('table[data-event-name]').length != 0) {
                    var eventName = row.closest('table[data-event-name]').data('event-name')
                    row.trigger(eventName, [row.data('id')]);
                } else if (row.data("href")) {
                    if (e.shiftKey || e.ctrlKey || e.metaKey) {
                        window.open(row.data("href"), '_blank');
                    } else {
                        window.document.location = row.data("href");
                    }
                }
            });

            // Sync all checked rows
            this._tableContainer.find('tr > td.cell-checkbox > input:checkbox:checked').each(function () {
                self.handleCheckboxToggle($(this));
            });

            $(document.body).on('click.jsqTableViewAll', '.new-partial-paginate-msg', function(e) {
                e.preventDefault();
                var url = window.location.href;
                var formData = new FormData();
                formData.append('fetch_all', true)

                ajax(url, {
                    method: 'POST',
                    formData: formData,
                });
            });

            $(document.body).off('click.jsqTableSelectAll').on('click.jsqTableSelectAll', '#select_all', function(e) {
                e.preventDefault();
                function select_all() {
                    $('tr > td.cell-checkbox > input:not(:disabled)').filter(':checkbox').each(function() {
                        $(this).prop('checked', true);
                        self.handleCheckboxToggle($(this));
                    });
                    self.updateButtonBar();
                }
                if (self.hasScrollPagination() || self.hasPartialPagination()) {
                    self.loadNextPage(self, select_all);
                } else {
                    select_all();
                }
            });

            $(document.body).off('click.jsqTableSelectNone').on('click.jsqTableSelectNone', '#select_none, #clear-selection', function(e) {
                e.preventDefault();
                $('tr > td.cell-checkbox > input').filter(':checkbox').each(function() {
                    $(this).prop('checked', false);
                    self.handleCheckboxToggle($(this));
                });
                self.updateButtonBar();
            });

            $(document.body).off('click.jsqTableSelectReverse').on('click.jsqTableSelectReverse', '#select_reverse', function(e) {
                e.preventDefault();
                $('tr > td.cell-checkbox > input:not(:disabled)').filter(':checkbox').each(function() {
                    var checkbox = $(this)
                    checkbox.prop('checked', !checkbox.prop('checked'));
                    self.handleCheckboxToggle(checkbox);
                });
                self.updateButtonBar();
            });

            this._tableContainer.find('table .show-hidden-rows').click(function(e) {
                $(this).closest('table').find('tr.hidden')
                                        .removeClass('hidden')
                                        .find('td')
                                        .wrapInner('<div style="display: none;" />')
                                        .parent()
                                        .find('td > div')
                                        .slideDown(300, function(){
                                            var $set = $(this);
                                            $set.replaceWith($set.contents());
                                        });
                $(this).closest('tr').addClass('hidden');
            });

            this._tableContainer.on('jsq:tableCellEdit.jsqTableContainerEvents', $.proxy(this.handleCellEdit, this));
            this._tableContainer.on('jsq:tableAddNewRow.jsqTableContainerEvents', $.proxy(this.addNewRow, this));
            this.pollRows(true/*retry*/);

            if (this._tableContainer.find('div.scroll-paginate-msg').length > 0) {
                this.registerScrollPagination();
            }
        };

        this.initFixedHeader = function() {
            var header = this._tableContainer.find('table > thead:not(.subheading):not(.no-fixed-header)');
            if (header.length == 0) {
                return;
            }
            if (!this._tableContainer.is(':visible')) {
                return;
            }

            var table = this._tableContainer.find('table');
            var tbody = table.find('tbody');
            table.css({position: 'relative'});
            var headerClone = header.clone(true).addClass('clone');
            headerClone.css('visibility', 'hidden');
            var headerCloneTds = headerClone.find('td');
            header.after(headerClone);
            var headerTds = header.find('td');
            var viewport = this._tableContainer.find('.table-scroller-viewport').first();
            var scrollerWidget = this._tableContainer.find('.table-scroller-widget').first();
            var useStickyHeader = false;

            if (viewport[0]) {
                header.css({overflowX: 'hidden'});
            }

            function syncTableScroll(event) {
                if (viewport[0]) {
                    header[0].scrollLeft = useStickyHeader ? viewport[0].scrollLeft : 0;
                }
            }
            viewport.on('scroll', syncTableScroll);

            function updateHeaderWidth() {
                var tableOffset = table.offset();
                var lastTd = headerTds.last();
                var tableWidth = table[0].offsetWidth;
                if (useStickyHeader && viewport[0]) {
                    tableWidth = Math.min(tableWidth, viewport.outerWidth());
                    header.css({
                        width: tableWidth,
                        minWidth: tableWidth,
                        maxWidth: tableWidth,
                        boxSizing: 'border-box',
                        background: 'white',
                    });
                } else {
                    header.css({
                        width: '',
                        minWidth: '',
                        maxWidth: '',
                        boxSizing: 'border-box',
                        background: 'white',
                    });
                }
            }

            function updateHeader(event) {
                // if the table is already hidden,
                // it doesn't make sense to perform any further re-calculations
                // since the DOM size methods always return 0 for elements hidden with display: none
                if (!table.is(":visible")) return;

                if (!$.contains(document.body, table[0])) {
                    $(window).off('scroll', updateHeader);
                    $(window).off('resize', updateHeader);
                    $(window).off('jsq:ajaxChangedDOM', updateHeader);
                    return;
                }

                var fixedNavbar = $('.navbar.navbar-fixed-top');
                var navbarHeight = 0;
                if (fixedNavbar.css('position') == 'fixed') {
                    navbarHeight = fixedNavbar.outerHeight();
                }

                var lastDataRow = tbody.find('tr:last-child');
                var tableOffset = table.offset();
                var scrollY = getWindowScrollY();
                var scrollX = getWindowScrollX();
                useStickyHeader = (scrollY > tableOffset.top - navbarHeight &&
                                    scrollY < lastDataRow.offset().top - navbarHeight);
                header.toggleClass('sticky', useStickyHeader);
                scrollerWidget.toggleClass('sticky', useStickyHeader);

                if (useStickyHeader) {
                    header.css({
                        position: 'fixed',
                        left: (viewport[0] ? viewport.offset().left : tableOffset.left) - scrollX,
                        top: navbarHeight,
                        zIndex: FIXED_HEADER_ZINDEX,
                    });
                } else {
                    header.css({
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: HEADER_DEFAULT_ZINDEX,
                    });
                }

                headerTds.each(function(i) {
                    var td = $(this);
                    var width = headerCloneTds.eq(i).outerWidth();
                    td.css({
                        boxSizing: 'border-box',
                        width: width,
                        maxWidth: width,
                        minWidth: width,
                    })
                });

                updateHeaderWidth();
                syncTableScroll();
            }

            updateHeader();
            header.find('td.row_selector .dropdown-toggle').click(function() {
                $(window).trigger('jsq:toggleRowSelector');
                updateHeader();
            });
            header.find('td.row_selector .dropdown-menu').click(updateHeader);
            $(window).on('scroll', updateHeader);
            $(window).on('resize', updateHeader);
            $(window).on('jsq:ajaxChangedDOM', updateHeader);
            this._tableContainer.on('jsq:tableResized.jsqTableContainerEvents', updateHeader);
        }

        this.initTableScroller = function() {
            var self = this;
            var fixedNavbar = $('.navbar.navbar-fixed-top');
            var table = this._tableContainer.find('table').first();
            if (!table.hasClass('enable_table_scroller')) return;

            var tbody = table.children('tbody').first();
            var sidebar = this._tableContainer.find('.table-scroller-sidebar').first();
            var sidebarHeader = sidebar.find('.table-scroller-sidebar-header').first();
            var sidebarContent = sidebar.find('.table-scroller-sidebar-content').first();

            var widget = this._tableContainer.find('.table-scroller-widget').first();
            var viewport = this._tableContainer.find('.table-scroller-viewport').first();

            if (this._previousViewportScrollLeft) {
                viewport[0].scrollLeft = this._previousViewportScrollLeft;
            }

            renderSidebar();
            var renderRequest = null;
            function bounceRenderSidebar() {
                if (window.requestAnimationFrame) {
                    cancelAnimationFrame(renderRequest);
                    renderSidebar({headerOnly:true});
                    renderRequest = requestAnimationFrame(function() {
                        renderSidebar();
                    });
                } else {
                    clearTimeout(renderRequest);
                    renderSidebar({headerOnly:true});
                    renderRequest = setTimeout(function() {
                        renderSidebar();
                    });
                }
            }
            $(window).on('scroll', bounceRenderSidebar);
            $(window).on('resize', bounceRenderSidebar);
            $(window).on('jsq:ajaxChangedDOM', renderSidebar);
            this._tableContainer.on('jsq:tableResized.jsqTableContainerEvents', renderSidebar);

            function isSmallScreen() {
                var thead = table.children('thead:visible:not(.clone)').first();
                return thead.find('td:visible').length <= 1;
            }

            function toggleOverflowedClasses() {
                self._previousViewportScrollLeft = viewport[0].scrollLeft;

                var smallScreen = isSmallScreen();
                if (smallScreen) {
                    viewport[0].scrollLeft = 0;
                }
                var overflowedLeft = smallScreen ? false : viewport[0].scrollLeft > 0;
                var overflowedRight = smallScreen ? false : viewport[0].scrollLeft + viewport[0].clientWidth < viewport[0].scrollWidth;
                widget.toggleClass('overflowed-left', overflowedLeft);
                widget.toggleClass('overflowed-right', overflowedRight);

                if (overflowedLeft) {
                    sidebar.css({
                        display: 'block',
                        height: '',
                        bottom: SCROLLBAR_HEIGHT + 'px'
                    });
                    sidebarContent.css({
                        display: 'block'
                    });
                }

                var select2open = widget.find('.select2-dropdown-open')[0];
                if (select2open) {
                    $('#select2-drop').css({
                        zIndex: SELECT2_ZINDEX,
                        paddingTop: 8,
                        borderTop: 'solid 1px #66afe9',
                        borderRadius: '4px',
                        boxShadow: '0 -2px 8px rgba(0,0,0,0.3)'
                    });

                    $('#select2-drop-mask').css({
                        zIndex: SELECT2_MASK_ZINDEX
                    });
                }

                sidebarContent.find('.table-scroller-fixed-column.info input:checkbox').prop('checked', true);
            }
            function handleMouseWheel(e) {
                if ($(e.target).closest('.select2-choices')[0]) return;

                viewport[0].scrollLeft += e.originalEvent.deltaX;
                window.scrollBy(0, e.originalEvent.deltaY);
                e.preventDefault();
                e.stopPropagation();
                bounceRenderSidebar();
            }
            viewport.on('wheel', handleMouseWheel);
            sidebar.on('wheel', handleMouseWheel);
            viewport.on('scroll', toggleOverflowedClasses);

            function renderSidebar(options) {
                if (!$.contains(document.body, table[0])) {
                    $(window).off('scroll', bounceRenderSidebar);
                    $(window).off('resize', bounceRenderSidebar);
                    $(window).off('jsq:ajaxChangedDOM', renderSidebar);
                    return;
                }

                if (isSmallScreen()) {
                    sidebar.css('display', 'none');
                    return;
                }

                sidebar.css('display', 'block');

                var headerOnly = options && options.headerOnly;
                var thead = table.children('thead:visible:not(.clone)').first();
                var headerCells = thead.find('th,td');
                var fixedEl = null;
                if (thead.hasClass('sticky')) {
                    fixedEl = thead;
                } else if (fixedNavbar.css('position') == 'fixed') {
                    fixedEl = fixedNavbar;
                }

                var adjustedHeight = fixedEl ? parseInt(fixedEl.css('top'), 10) + fixedEl.outerHeight() : 0;

                var scrollY = getWindowScrollY();
                var minScreenY = scrollY + adjustedHeight;
                var maxScreenY = minScreenY + window.innerHeight - adjustedHeight;

                var allRows = tbody.children('tr');
                var tableTop = table.offset().top;

                // Offscreen, no rendering needed
                if (tableTop + allRows[0].offsetTop > maxScreenY) return;

                var topVisibleRowIndex, bottomVisibleRowIndex;
                var topVisibleRow = null, bottomVisibleRow = null;
                for (var i = 0, n = allRows.length; i < n; i++) {
                    topVisibleRow = allRows[i];
                    topVisibleRowIndex = i;
                    if (tableTop + topVisibleRow.offsetTop + topVisibleRow.offsetHeight >= minScreenY) {
                        break;
                    }

                    // Offscreen, no rendering needed
                    if (i == n - 1) return;
                }

                for (; i < n; i++) {
                    bottomVisibleRow = allRows[i];
                    bottomVisibleRowIndex = i;
                    if (tableTop + bottomVisibleRow.offsetTop + bottomVisibleRow.offsetHeight >= maxScreenY) {
                        break
                    }
                }

                var sidebarHeaderBuffer = [];
                var sidebarContentBuffer = [];
                var firstRowCells = $(topVisibleRow).children('td, th');
                var firstDataIndex = firstRowCells.eq(0).hasClass('cell-checkbox') ? 1 : 0;
                var j, cell;

                var theadFixed = fixedEl === thead;
                sidebar.css('zIndex', theadFixed ? FIXED_HEADER_ZINDEX: SIDEBAR_DEFAULT_ZINDEX);
                for (j = 0; j <= firstDataIndex; j++) {
                    cell = headerCells[j];
                    var headerCellTop = theadFixed ? fixedEl.css('top') : cell.offsetTop + 1 + 'px';
                    var headerCellLeft = theadFixed ? (parseFloat(fixedEl.css('left'), 10) + cell.offsetLeft) + 'px'
                                                    : cell.offsetLeft + 'px';
                    var headerCellPosition = theadFixed ? 'fixed' : 'absolute';
                    var headerCellOffsetHeight = theadFixed ? cell.offsetHeight + 2 + 'px' : cell.offsetHeight + 1 + 'px';
                    sidebarHeaderBuffer.push('<div class="table-scroller-fixed-column header ' + cell.className + '"' +
                        ' data-sort-key="' + cell.getAttribute('data-sort-key') + '"' +
                        ' data-sort-dir="' + cell.getAttribute('data-sort-dir') + '"' +
                        ' style="' +
                                'position:' + headerCellPosition + ';' +
                                'top:' + headerCellTop + ';' +
                                'left:' + headerCellLeft + ';' +
                                'width:' + (cell.offsetWidth) + 'px;' +
                                'height:' + headerCellOffsetHeight + '"' +
                        '>' + cell.innerHTML + '</div>');
                }

                if (!headerOnly) {
                    for (i = topVisibleRowIndex; i <= bottomVisibleRowIndex; i++) {
                        var row = allRows[i];
                        var hasInfoClass = $(row).hasClass('info');
                        var isFirstVisibleRow = i == topVisibleRowIndex;
                        var isLastVisibleRow = i == bottomVisibleRowIndex;
                        var isLastTableRow = i == allRows.length - 1;
                        var cells = row.children;
                        var firstCell = cells[0];

                        // Leave some space at the top and bottom to let the
                        // borders of the underlying table row show up.
                        // This way we do not need to render borders per table-scroller-fixed-column
                        // and we avoid small but ugly off-by-one rendering differences
                        // between table-scroller-fixed-column and its underlying table row.
                        // The severity of the off-by-one rendering varies by browser,
                        // Chrome being the only browser that renders without any issue.
                        var cellTop = firstCell.offsetTop + 2;
                        var cellHeight = firstCell.offsetHeight - 4;
                        if (isLastTableRow) {
                            cellHeight -= SCROLLBAR_HEIGHT; // Leave some space for the horizontal scrollbar at the bottom;
                        }

                        if (isFirstVisibleRow) {
                            sidebarContentBuffer.push('<div class="table-scroller-offscreen-mask top-mask" style="height: ' + (cellTop-2) + 'px"></div>');
                        } else if (isLastVisibleRow && !isLastTableRow) {
                            sidebarContentBuffer.push('<div class="table-scroller-offscreen-mask bottom-mask" style="top: ' + (cellTop + cellHeight) + 'px"></div>');
                        }

                        for (j = 0; j <= firstDataIndex; j++) {
                            cell = cells[j];
                            sidebarContentBuffer.push(
                                '<div class="table-scroller-fixed-column ' + cell.className +
                                                                  (hasInfoClass ? ' info ' : '') +
                                                                  '"' +
                                    ' data-row-index="' + i + '"' +
                                ' style="' +
                                            'top:' + cellTop +'px;' +
                                            'left:' + (cell.offsetLeft) +'px;' +
                                            'width:' + (cell.offsetWidth) +'px;' +
                                            'height:' + cellHeight +'px;' +
                                '">' + cell.innerHTML + '</div>'
                            );
                        }
                    }
                }

                var sidebarHeaderHtml = sidebarHeaderBuffer.join('');
                if (sidebarHeaderHtml.trim() != sidebarHeader[0].innerHTML.trim()) {
                    sidebarHeader.html(sidebarHeaderHtml);
                }

                if (!headerOnly) {
                    var sidebarContentHtml = sidebarContentBuffer.join('');
                    if (sidebarContentHtml.trim() != sidebarContent[0].innerHTML.trim()) {
                        sidebarContent.html(sidebarContentHtml);
                    }
                }

                var sidebarWidth = firstRowCells[firstDataIndex].offsetLeft + firstRowCells[firstDataIndex].offsetWidth - 0.5;
                sidebar.css('width', sidebarWidth);
                toggleOverflowedClasses();
            }
        };

        this.pollRows = function(retry) {
            var rowsToPoll = this._tableContainer.find('table tr[data-action="poll"]');
            if (rowsToPoll.length == 0) {
                return;
            }

            var self = this;
            var pollUrl = this._tableContainer.find('table').data('poll-url');
            rowsToPoll.each(function() {
                var rowId = $(this).data('id');
                ajax(pollUrl.replace('/000', '/'+rowId))
            });
            if (retry) {
                setTimeout(function(){
                    self.pollRows(retry);
                }, 5000);
            }
        }

        var checkboxTimer = null;
        this.handleCheckboxToggle = function(checkbox) {
            var id = checkbox.attr('id');
            var isChecked = checkbox.prop('checked');

            var parentRow = checkbox.closest('tr');
            var cellCheckbox;
            var sidebarCheckbox;
            var sidebarContent;

            if (parentRow[0]) {
                sidebarContent = this._tableContainer.find('.table-scroller-sidebar-content');
                sidebarCheckbox = sidebarContent.find('input#' + id);
                cellCheckbox = checkbox;
            } else {
                var table = this._tableContainer.find('table');
                sidebarCheckbox = checkbox;
                sidebarContent = sidebarCheckbox.closest('.table-scroller-sidebar-content');
                cellCheckbox = table.find('input#' + id);
                parentRow = cellCheckbox.closest('tr');
            }

            parentRow.toggleClass('info', isChecked);
            if (sidebarContent[0]) {
                sidebarCheckbox.prop('checked', isChecked);
                cellCheckbox.prop('checked', isChecked);

                if (isChecked) {
                    sidebarCheckbox.attr('checked', 'checked');
                    cellCheckbox.attr('checked', 'checked');
                } else {
                    sidebarCheckbox.removeAttr('checked');
                    cellCheckbox.removeAttr('checked');
                }

                var rowIndex = sidebarCheckbox.closest('.table-scroller-fixed-column').attr('data-row-index');
                var fixedColsInSameRow = sidebarContent.find('.table-scroller-fixed-column[data-row-index="' + rowIndex + '"]');
                fixedColsInSameRow.toggleClass('info', isChecked);

                var self = this;
                clearTimeout(checkboxTimer);
                checkboxTimer = setTimeout(function() {
                    self._tableContainer.trigger('jsq:tableResized');
                }, 0);
            }
        }

        var popoverButtons = '<div>' +
                             '<button type="button" class="btn btn-primary btn-sm submit">' +
                               '<i class="glyphicon glyphicon-ok"></i></button>' +
                             '<button type="button" class="btn btn-default btn-sm cancel">' +
                               '<i class="glyphicon glyphicon-remove"></i></button>' +
                             '</div>'
        this.initInlineEditPopover = function(cell, url) {
            require(['components/form', 'components/ajax'], function(form, ajax) {
                cell.find('form').each(function() {
                    form.init($(this))
                });
                cell.find('button.cancel').click(function() {
                    cell.children('span').popover('hide');
                });
                var self = this;
                cell.find('button.submit').click(function(e) {
                    var formData = form.serialize($(this).closest('form'));
                    ajax(url, {
                        formData: formData,
                        onSuccess: function(result) {
                            cell.html(result.body);
                            cell.children('span').popover('destroy');
                        },
                        onFailure: function(result) {
                            cell.find('.popover-content').html('<form class="form-horizontal" role="form">' + result.content + popoverButtons +'</form>')
                            self.initInlineEditPopover(cell, url);
                        }
                    });
                });
            });
        }

        this.submitInlineEdit = function(cell, value, restoreCellValueFn) {
            var cellContainer = cell.find('.cell-edit-link');
            var rowId = cell.closest('tr').data('id');
            var editUrl = cell.closest('table').data('edit-url').replace('-_-', rowId)
            var formData = new FormData();
            var fieldName = cell.data('field-name');
            if ($.isArray(value)) {
                value.forEach(function(val) {
                    formData.append(fieldName, val);
                });
            } else {
                formData.append(fieldName, value);
            }
            var totalsShown = $('.row-totals').length > 0;
            formData.append('table_totals_shown', totalsShown);
            ajax(editUrl, {
                formData: formData,
                onSuccess: function(result) {
                    var rawValues = result.raw_values && result.raw_values[fieldName]
                    var newValue = result.values && result.values[fieldName] || '';
                    var isEnum = cell.attr('data-field-type') == 'enumeration';

                    if (!rawValues) {
                        rawValues = isEnum ? '[]' : '';
                    }
                    if (typeof cell.attr('data-values') == 'string') {
                        cell.attr('data-values', rawValues);
                    }
                    restoreCellValueFn(newValue, rawValues);
                    $(window).trigger('jsq:updateCell');
                },
                onFailure: function(result) {
                    cellContainer.tooltip({
                        'title': result.error_message[fieldName],
                        'placement': 'top',
                        'trigger': 'manual',
                    }).tooltip('show');
                },
            });
        }

        function getCellCurrentValue(cell, cellContainer, asArray) {
            var cellOldValueJson = cell.attr('data-values');
            if (cellOldValueJson) {
                var values = JSON.parse(cellOldValueJson);
                return asArray ? values : values[0];
            } else {
                var value = $.trim(cellContainer.text());
                if (asArray) return value ? [value] : [];
                return value;
            }
        }

        this.initCellEditInput = function(cell) {
            if (cell.find('input').length > 0) {
                return
            }
            var cellContainer = cell.find('.cell-edit-link');
            if (cellContainer.length == 0) {
                return;
            }
            var cellOldValue = getCellCurrentValue(cell, cellContainer, false)
            var currencySymbol = cell.data('input-currency-symbol') || "$"
            // Create the edit area and input field. Set the value via javscript below instead of inline in the HTML
            // so that caret is placed at end of input field.
            var editArea = $('<div class="edit-area"><input type="text"/></div>').attr("data-input-currency-symbol", currencySymbol).appendTo(cellContainer);


            var cellInput = editArea.find('input');
            cellContainer.addClass('editing');

            cellInput.keydown(function(e) {
                cellContainer.tooltip('destroy');
                // Submit the value on 'enter'
                if (e.keyCode == 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    submitCellValue($(this));
                    return false;
                }
                // Restore the value on 'escape'
                if (e.keyCode == 27) {
                    e.preventDefault();
                    e.stopPropagation();
                    restoreCellValue(stringsComponent.escapeHtml(cellOldValue));
                    return false;
                }
            });

            if (cell.data('input-type') == 'date') {
                cellInput.val(cellOldValue)
                cellInput.addClass('datepicker-field');
                formComponent.initDatePicker(cell);
                cellInput.focus();
            } else {
                if (cell.data('input-type') == 'percentile') {
                    cellOldValue = cellOldValue ? (cellOldValue + '').replace('%', '') : '';
                } else if (cell.data('input-type') == 'currency_usd') {
                    cellOldValue = cellOldValue ? (cellOldValue + '').replace(currencySymbol, '') : '';

                }

                cellInput.val(cellOldValue);
                cellInput.focus();
            }

            var self = this;
            function submitCellValue() {
                var cellNewValue = cellInput.val();
                if (cellNewValue == cellOldValue) {
                    restoreCellValue(stringsComponent.escapeHtml(cellOldValue));
                    return;
                }
                self.submitInlineEdit(cell, cellNewValue, restoreCellValue);
            }

            var timer = null;
            function scheduleSubmit() {
                clearTimeout(timer);
                timer = setTimeout(submitCellValue, 100);
            }

            function restoreCellValue(newValue, newRawValue) {
                if (cellInput.data('datepicker')) {
                    cellInput.datepicker('close');
                }

                cellContainer.tooltip('destroy');
                if (newValue) {
                    // Use regexes, IE does not support endsWith and startsWith.
                    var dollar_pattern = /^\$/;
                    var percent_pattern = /%$/;
                    var currencySymbol = cell.data('input-currency-symbol') || "$"
                    var currencyPattern = new RegExp("^" + currencySymbol);

                    if (cell.data('input-type') == 'percentile' && !percent_pattern.test(newValue)) {
                        newValue += '%';
                    } else if (cell.data('input-type') == 'currency_usd' && !dollar_pattern.test(newValue) && !currencyPattern.test(newValue)) {
                        newValue = currencySymbol + newValue;
                    }

                    cellContainer.html(newValue);
                } else {
                    cellContainer.html('&nbsp;');
                }
                cellContainer.removeClass('editing');

                setTimeout(function() {
                    self._tableContainer.trigger('jsq:tableResized');
                }, 0);
            }
            if (cellInput.data('datepicker')) {
                cellInput.datepicker().on('hide', function() {
                    scheduleSubmit();
                });
            } else {
                cellInput.blur(scheduleSubmit);
            }
        }

        this.initCellEditSelect = function(cell) {
            if (cell.find('select').length > 0) {
                return
            }
            var cellContainer = cell.find('.cell-edit-link');
            var cellText = cell.text();
            var cellValues = getCellCurrentValue(cell, cellContainer, true);
            var fieldName = cell.data('field-name');
            var selectTemplate = $('#' + fieldName + '-dropdown-template').data('payload')
            var currencySymbol = cell.data('input-currency-symbol') || "$"
            // Create the edit area and select field
            var editArea = $('<div class="edit-area"></div>').attr("data-input-currency-symbol", currencySymbol).appendTo(cellContainer);
            var cellSelect = $(selectTemplate).appendTo(editArea);
            cellContainer.addClass('editing');

            if (typeof cell.attr('data-values') == 'string') {
                cellValues.forEach(function(value) {
                    cellSelect.find('option[value="' + value + '"]').prop('selected', true);
                });
            } else {
                cellValues.forEach(function(value) {
                    cellSelect.find('option').each(function() {
                        if (this.innerText == value) {
                            $(this).prop('selected', true);
                        }
                    });
                });
            }

            var self = this;

            var restoreCellValue = function(newValue) {
                cellContainer.html(newValue || '&nbsp;');
                cellContainer.removeClass('editing');

                setTimeout(function() {
                    self._tableContainer.trigger('jsq:tableResized');
                }, 0);
            }

            cellSelect.select2();
            if (cellSelect.attr('multiple')) {
                if (cellSelect.find('option:checked').length != cellSelect.find('option').length) {
                    setTimeout(function() {
                        cellSelect.select2('open');
                    }, 100);
                }

                // eslint-disable-next-line no-inner-declarations
                function onPressDown(event) {
                    if (!$(event.target).closest('.select2-container')[0]) {
                        if (!cell.find('.select2-container')[0]) return;
                        $(window).off('mousedown', onPressDown);
                        $(window).off('touchend', onPressDown);
                        self.submitInlineEdit(cell, cellSelect.val() || [], restoreCellValue);
                    }
                }

                setTimeout(function() {
                    $(window).on('mousedown', onPressDown);
                    $(window).on('touchend', onPressDown);
                }, 1000);

                // eslint-disable-next-line no-inner-declarations
                function cancel() {
                    cellSelect.select2('close');
                    $(window).off('mousedown', onPressDown);
                    $(window).off('touchend', onPressDown);
                    restoreCellValue(stringsComponent.escapeHtml(cellText));
                }

                $(window).one('jsq:toggleRowSelector', cancel);

                // eslint-disable-next-line no-inner-declarations
                function handleKey(e) {
                    if (e.keyCode == 27) {
                        // ESC pressed, cancel.
                        e.preventDefault();
                        e.stopPropagation();
                        cancel();
                        return false;
                    } else if (e.keyCode == 13) {
                        // ENTER pressed, finish.
                        e.preventDefault();
                        e.stopPropagation();
                        cellSelect.select2('close');
                        $(window).off('mousedown', onPressDown);
                        $(window).off('touchend', onPressDown);
                        self.submitInlineEdit(cell, cellSelect.val() || [], restoreCellValue);
                        return false;
                    }
                }
                cellSelect.on('select2-open', function() {
                    cell.find('.select2-input').off('keydown', handleKey);
                    self._tableContainer.trigger('jsq:tableResized');
                });
                cellSelect.on('select2-close', function() {
                    cell.find('.select2-input').on('keydown', handleKey);
                });
            } else {
                cellSelect.on('select2-open', function() {
                    self._tableContainer.trigger('jsq:tableResized');
                });

                setTimeout(function() {
                    cellSelect.select2('open');
                }, 100);

                cellSelect.on('select2-close', function() {
                    self.submitInlineEdit(cell, cellSelect.val() || [], restoreCellValue);
                });
            }
        }

        this.initCellEditPopover = function(cell) {
            // Instantiate the popover control if it doesnt already exist
            var rowId = cell.closest('tr').data('id');
            var url = cell.closest('table').data('edit-url') + '/' + rowId;
            var self = this;
            if (cell.children('div.popover').length == 0){
                $.ajax({
                    url: url,
                    type: 'GET',
                    processData: false,
                    dataType: 'json',
                    success: function(result) {
                        cell.children('span').popover({
                            html: true,
                            title: result.title,
                            placement: 'left',
                            content: '<form class="form-horizontal" role="form">' + result.content + popoverButtons +'</form>'
                        });
                        cell.children('span').popover('show');
                        self.initInlineEditPopover(cell, url);
                    }
                });
            } else {
                self.initInlineEditPopover(cell, url);
            }
        }


        this.handleCellEdit = function(event, rowId, rowHref) {
            var self = this;
            var cell = $(event.target);
            if (cell.hasClass('editable-inline-input')) {
                this.initCellEditInput(cell);
            } else if (cell.hasClass('editable-inline-select') || event.target.firstElementChild.classList.contains('editable-inline-select')) {
                this.initCellEditSelect(cell);
            } else {
                this.initCellEditPopover(cell);
            }
        }

        this._windowScrollRegistered = false;
        this.scrollPaginationInProgress = false;
        this.loadedAllTrContent = false;

        this.registerScrollPagination = function(base_url) {
            if (this._windowScrollRegistered) {
                this.scrollPaginationInProgress = false;
                return;
            }

            var self = this;
            self._windowScrollRegistered = $(window).scroll(function() {
                if($(window).scrollTop() + $(window).height() > self._tableContainer.height() &&
                   !self.scrollPaginationInProgress && !self.loadedAllTrContent) {
                    self.scrollPaginationInProgress = true;

                    // Tell the user we're loading posts
                    var statusMessage = self._tableContainer.find('div.scroll-paginate-msg');
                    statusMessage.removeClass('invisible');

                    // Run the function to fetch the data inside a delay
                    // This is useful if you have content in a footer you
                    // want the user to see.
                    setTimeout(self.loadNextPage(self), 100);
                }
            });
        };

        this.expandRow = function(row) {
            if (row.is('.expando-expanding')) {
                return;
            }
            var self = this;
            var getExpandoContent = function(innerContent, checkbox) {
                if (row.is('.expando-fullwidth') || row.is('.expando-toggle')) {
                    var checkbox_html = checkbox !== "" ? checkbox : "";
                    var cells = checkbox_html + "<td colspan=\"" + row[0].cells.length + "\">" + innerContent + "</td>";
                    var detailsClass = ' expando-toggle';
                } else {
                    var cells = "<td></td><td colspan=\"" + (row[0].cells.length-1) + "\">" + innerContent + "</td>";
                    var detailsClass = '';
                }
                return "<tr class=\"expando-details" + detailsClass + " no-row-hover\">" + cells + "</tr>";
            }

            if (row.hasClass('expando-collapsed')) {
                var nextRow = row.next();
                row.removeClass('expando-collapsed');
                if (nextRow.is('.expando-details') && !(nextRow.is('.expando-toggle'))) {
                    row.find('span.caret').removeClass('caret-right');
                    row.addClass('expando-expanded');
                    row.nextUntil(':not(.expando-details)').removeClass('hidden');
                } else {
                    row.addClass('expando-expanding');
                    var spinnerContent = '<img src="/static/spinner_sm.gif" width="16" height="16"> loading...';
                    var newRow = row.after(getExpandoContent(spinnerContent)).next();
                    var expandoContentUrl = row.data("href");
                    $.ajax({
                        url: expandoContentUrl,
                        type: 'GET',
                        dataType: 'json',
                        success: function(result) {
                            row.find('span.caret').removeClass('caret-right');
                            row.removeClass('expando-expanding');
                            row.addClass('expando-expanded');
                            newRow.replaceWith(getExpandoContent(result.body, result.checkbox));
                            var detailsRow = row.next();
                            var onCloseFn = function() {
                                // refresh row, as it may be a stale copy!
                                var dataId = row.attr('data-id');
                                row = $('tr[data-id="' + dataId + '"]');

                                var oldCheckbox = detailsRow.find(
                                    "input:checkbox[id^='checkbox_internal_']"
                                );
                                var newCheckbox = row.find("input:checkbox[id^='checkbox_']");
                                self.passStateToCheckbox(oldCheckbox, newCheckbox, false);

                                if (row.is('.expando-toggle')) {
                                    detailsRow.remove();
                                } else {
                                    detailsRow.addClass('hidden')
                                }
                                row.find('span.caret').addClass('caret-right');
                                row.removeClass('expando-expanded');
                                row.addClass('expando-collapsed');
                            };
                            self.initRowEdit(detailsRow, expandoContentUrl, onCloseFn, row);

                            // If this expando has a component, then initialize it
                            if (Object.prototype.hasOwnProperty.call(result, 'component')) {
                                require(['components/'+result.component], function(component) {
                                    if (result.component == 'email_batch_delay_send' ) {
                                        component.init(detailsRow, result.email_batch_id, result.email_batch_schedule_send_time, result.tz_str);
                                    } else{
                                        component.init(detailsRow);
                                    }
                                });
                            }
                        },
                        error: function(result) {
                            row.removeClass('expando-expanding');
                            row.addClass('expando-collapsed');
                            row.next().remove();
                        }
                    });
                }
            } else {
                row.find('span.caret').addClass('caret-right');
                row.nextUntil(':not(.expando-details)').addClass('hidden');
                row.removeClass('expando-expanded');
                row.addClass('expando-collapsed');
            }
        };

        this.expandSubheading = function(row) {
            var regionId = row.data('region');
            if (!regionId) {
                return
            }

            if (row.hasClass('expando-collapsed')) {
                row.find('.caret.caret-right-large').removeClass('caret-right-large').addClass('caret-large');
                row.removeClass('expando-collapsed');
                row.addClass('expando-expanded');

                row.siblings('tr[data-region=' + regionId + ']').removeClass('hidden');
            } else {
                row.find('.caret.caret-large').removeClass('caret-large').addClass('caret-right-large');
                row.removeClass('expando-expanded');
                row.addClass('expando-collapsed');
                row.siblings('tr[data-region=' + regionId + ']').addClass('hidden');
            }
        };

        this.addNewRow = function(e, addNewUrl) {
            var numColumns = this._tableContainer.find('table.biglist > thead > tr')[0].cells.length;

            var getNewRowContent = function(innerContent) {
                var cells = "<td colspan=\"" + numColumns + "\">" + innerContent + "</td>";
                return "<tr class=\"expando-details expando-toggle no-row-hover\">" + cells + "</tr>";
            }

            var spinnerContent = '<img src="/static/spinner_sm.gif" width="16" height="16"> loading...';

            // Add either after the last row or before the first row (ie, after the header) depending
            // on the table configuration.  Default is after the last row.
            var lastRow = this._tableContainer.find('table.biglist > tbody > tr:last');
            var rowPosition = this._tableContainer.find('table.biglist').data('new-row-position');
            if (lastRow.length == 0 || rowPosition == 'top') {
                var newRow = this._tableContainer.find('table.biglist > tbody')
                                                 .prepend(getNewRowContent(spinnerContent))
                                                 .children()
                                                 .first();
            } else {
                var newRow = lastRow.after(getNewRowContent(spinnerContent)).next();
            }
            var self = this;
            $.ajax({
                url: addNewUrl,
                type: 'GET',
                dataType: 'json',
                success: function(result) {
                    var oldRow = newRow;
                    newRow = oldRow.after(getNewRowContent(result.body)).next();
                    oldRow.remove();

                    var onCloseFn = function() {
                        newRow.remove();
                        self._tableContainer.find('.no-data-message').remove();
                    };
                    self.initRowEdit(newRow, addNewUrl, onCloseFn, null);

                    // If this expando has a component, then initialize it
                    if (Object.prototype.hasOwnProperty.call(result, 'component')) {
                        require(['components/'+result.component], function(component) {
                            component.init(newRow);
                        });
                    }
                },
                error: function(result) {
                    newRow.remove();
                }
            });
        };

        this.showOverlay = function(row) {
            var overlay = row.closest('.table-overlay');
            var loading = overlay.find('.loading-overlay');
            loading.removeClass('hidden');

            var stateData = {
                'component': 'table',
                'tableId': this._tableContainer.attr('id'),
                'overlayHref': row.data('href'),
            }
            History.pushState(stateData, document.title, stateData.overlayHref);
        };

        this.overlayStateChangeHandler = function() {
            // Handle only state changes triggered by this component
            var state = History.getState();
            if (!state.data || !Object.prototype.hasOwnProperty.call(state.data, 'component') || state.data.component != 'table') {
                return;
            }
            if (!tableOverlay || tableOverlay.length == 0) {
                return;
            }
            var overlayContainer = tableOverlay.find('.overlay-container');
            var dataContainer = tableOverlay.find('.data-container');

            // The state change must either be to close the overlay or open an overlay with an href
            if (Object.prototype.hasOwnProperty.call(state.data, 'closeOverlay')) {
                dataContainer.removeClass('hidden');
                overlayContainer.addClass('hidden');
                return;
            } else if (!Object.prototype.hasOwnProperty.call(state.data, 'overlayHref')) {
                // This should not happen
                return;
            }

            var loading = tableOverlay.find('.loading-overlay');

            ajax(state.data.overlayHref, {
                onSuccess: function(result) {
                    loading.addClass('hidden');
                    overlayContainer.html(result.body)
                                    .removeClass('hidden');
                    domSetup.init(overlayContainer);
                    if (Object.prototype.hasOwnProperty.call(result, 'component')) {
                        require(['components/'+result.component], function(component) {
                            component.init(overlayContainer);
                        });
                    }
                    dataContainer.addClass('hidden');
                    if(typeof window.__jsqRenderPillars__ === 'function') {
                        window.__jsqRenderPillars__();
                    }
                }
            });
        };

        /**
         * Passes state between internal and external row checkboxes.  For use when checkbox appears inside an expando row
         * in a table.
         * @param oldCheckbox old checkbox
         * @param newCheckbox new checkbox
         * @param isOpen is expando row open or closed
         */
        this.passStateToCheckbox = function(oldCheckbox, newCheckbox, isOpen) {
            if (oldCheckbox.length >= 1 && newCheckbox.length >= 1) {
                var newCheckboxId = '#' + newCheckbox[0].id;
                var oldCheckboxId = '#' + oldCheckbox[0].id;
                $(newCheckboxId).prop('checked', oldCheckbox[0].checked);
                $(oldCheckboxId).prop('checked', false);
                $(oldCheckboxId).prop('disabled', true);
                // use this to determine if newCheckbox should be enabled or disabled
                var isNewDisabled = isOpen
                    ? false
                    : !$(newCheckboxId)
                        .closest('tr')
                        .hasClass('bg-warning');
                $(newCheckboxId).prop('disabled', isNewDisabled);
                this.handleCheckboxToggle(newCheckbox);
            }
        };

        this.initRowEdit = function(row, saveUrl, onCloseFn, editedRow) {
            var self = this;
            var newCheckbox = row.find("input:checkbox[id^='checkbox_internal_']");
            var oldCheckbox = editedRow
                ? editedRow.find("input:checkbox[id^='checkbox_']")
                : [];
            this.passStateToCheckbox(oldCheckbox, newCheckbox, true);

            row.on('click', 'button', function(e) {
                var button = $(e.target);
                if (button.is('.close-expando')) {
                    e.preventDefault();
                    e.stopPropagation();
                    onCloseFn();
                    return false;
                }
                if (button.attr('name') == 'save') {
                    e.preventDefault();
                    e.stopPropagation();
                    require(['components/form'], function(form) {
                        var formEl = button.closest('form');
                        if (!formEl[0]) {
                            formEl = row.find('form');
                        }
                        var formData = form.serialize(formEl);
                        var url = button.attr('data-url') || saveUrl;
                        button.addClass('disabled')
                              .prop('disabled', true);
                        ajax(url, {
                            formData: formData,
                            onSuccess: function(result) {
                                var newRow = null;
                                var existingRow = editedRow || row;

                                if (typeof result.body == 'string') {
                                    newRow = existingRow.after(result.body).next();
                                    existingRow.remove();
                                }

                                onCloseFn();

                                if (newRow[0] && result.expandImmediately) {
                                    setTimeout(function() {
                                        self.expandRow(newRow);
                                    }, 0);
                                }

                                if ($('button.transaction_publish').length > 0 && $('#edit-transaction-batch').length === 0 && !$('.expando-details-view').hasClass('hidden')) {
                                    $('button.transaction_publish').prop('disabled', false);
                                }
                            },
                            onFailure: function(result) {
                                $(row[0].cells[0]).html(result.body);
                                domSetup.init(row);
                                if (Object.prototype.hasOwnProperty.call(result, 'component')) {
                                    require(['components/'+result.component], function(component) {
                                        component.init(row);
                                    });
                                }
                            },
                            onComplete: function() {
                                button.removeClass('disabled')
                                      .prop('disabled', false);
                            }
                        });
                    });
                    return false;
                }
                if (button.attr('name') == 'delete') {
                    e.preventDefault();
                    e.stopPropagation();
                    var deleteUrl = button.data('href');
                    ajax(deleteUrl, {
                        onSuccess: function(result) {
                            onCloseFn();
                            editedRow.children('td, th')
                                     .animate({padding: 0})
                                     .wrapInner('<div/>')
                                     .children()
                                     .slideUp(300, function(){
                                        editedRow.remove();
                                     });
                            /*
                            editedRow.html('<td colspan="' + editedRow[0].cells.length + '">Click to undo delete</td>')
                            editedRow.data('href', deleteUrl + '?undelete=1');
                            */
                        }
                    });
                    return false;
                }
                return true;
            });
        };

        this.hasScrollPagination = function() {
            return this._tableContainer.find('div.scroll-paginate-msg')[0];
        };

        // only positions and capital call table use partial pagination
        // (click load-all link to load the rest positions)
        // other list like contacts list use scroll pagination
        this.hasPartialPagination = function() {
            return this._tableContainer.find('.partial-paginate-msg')[0];
        };

        this.testAccountPositionsPathname = function(input) {
            var regex = /\/account\/[0-9]+\/positions/i;
            return regex.test(input);
        }

        this.loadNextPage = function(self, fetch_all_cb) {
            fetch_all_cb = fetch_all_cb || false;

            var statusMessage = self._tableContainer.find('div.scroll-paginate-msg');
            var paginate_url = window.location.href;
            var offset = self._tableContainer.find('tbody tr').not('.expando-details, .expando-details tr').length;
            var formData = new FormData();
            formData.append('offset', offset);

            if (fetch_all_cb) {
                formData.append('fetch_all', 1);
                self.toggleLoadingOverlay(true);
            }
            // for position list, add limit=-1 to query string to load all positions for select-all
            if (self.testAccountPositionsPathname(paginate_url) && fetch_all_cb){
                var url = new URL(paginate_url);
                url.searchParams.append('limit', -1);
                paginate_url = url.href
            }

            ajax(paginate_url, {
                formData: formData,
                onSuccess: function(result) {
                    statusMessage.addClass('invisible');

                    var filteredCount = $('.filtered-count');
                    self.scrollPaginationInProgress = false;
                    // replace all children with response body for position-list
                    if (self.testAccountPositionsPathname(paginate_url) && self._tableContainer[0]){
                        self._tableContainer.children().replaceWith(result.body);
                        self._tableContainer.find('td.cell-checkbox > input:checkbox:checked').each(function () {
                            self.handleCheckboxToggle($(this));
                        });
                    } else {
                        //  append new response body to the end
                        var lastRow = self._tableContainer.find('tr:not(.row-totals):last').after(result.body);
                        lastRow.nextAll().find('td.cell-checkbox > input:checkbox:checked').each(function () {
                            self.handleCheckboxToggle($(this));
                        });
                    }

                    if (fetch_all_cb) {
                        fetch_all_cb();
                        self.toggleLoadingOverlay(false);
                    }

                    // Check to see if all table content is loaded to prevent future unnecessary
                    // requests on sidebar scroll. This is signified by the result body string
                    // not containing a tr tag in it's html.
                    if (Object.prototype.hasOwnProperty.call(result, 'body') && result.body.indexOf('tr') === -1) {
                        self.loadedAllTrContent = true;
                    } else {
                        self.loadedAllTrContent = false;
                    }

                    // Update the record count if present
                    var rowCount = self._tableContainer.find('tbody tr:not(.row-totals)').length;
                    filteredCount.html(rowCount);

                    // Update or insert totals data if present in the respond (on last page)
                    if (result.totals) {
                        // Remove any existing rows
                        self._tableContainer.find('tbody tr.row-totals').remove();

                        // Append the totals
                        self._tableContainer.find('tbody tr:last').after(result.totals);
                    }

                    $(window).trigger('jsq:ajaxChangedDOM');
                },
                onFailure: function(result) {
                    // Leave the autoscroll disabled (ie. self.scrollPaginationInProgress=True)
                    statusMessage.text(result.status_msg);
                    if (fetch_all_cb) {
                        fetch_all_cb();
                        self.toggleLoadingOverlay(false);
                    }
                },
            });
        };

        this.getLoadingOverlay = function() {
            if (this._tableContainer[0]) {
                return this._tableContainer.closest('.table-overlay');
            }
            return $('.table-overlay');
        }

        this.toggleLoadingOverlay = function(state) {
            var tableOverlay = this.getLoadingOverlay();
            if (tableOverlay.length == 0) {
                return;
            }

            var loading = tableOverlay.find('.loading-overlay');
            if (state == true) {
                loading.removeClass('hidden');
            } else {
                loading.addClass('hidden');
            }
        };

    };

    return table;
});

